import mixins from 'synergycms_core/src/less/mixins';

export default {
  orderByTitle: {
    fontSize: '18px',
    padding: '11px 45px 14px 20px',
    borderBottom: '1px solid #d8d8d8',
    position: 'relative',
    '@media (min-width: 1000px),print': {
      padding: '2px 45px 14px 9px',
      border: 'none',
      fontSize: '16px',
      fontWeight: '500'
    },
    '&:lang(ar)':{
      paddingLeft:'45px',
      paddingRight:'20px',
      '@media (min-width: 1000px),print': {
        paddingLeft:'45px',
        paddingRight:'9px'
      }
    }
  },
  listContainer: {
    padding: '20px',
    '@media (min-width: 1000px),print': {
      padding: 0
    }
  },
  disabled: {},
  defaultStyle: {
    maxHeight: '999px',
    zIndex: '5',
    display: 'none',
    position: 'absolute',
    left: '0',
    right: '0',
    top: '100%',
    background: '#fff',
    overflow: 'hidden',
    boxSizing: 'content-box',
    border: '0',
    color: 'inherit',
    padding: '14px',
    fontFamily: data => data.fontFamily1,
    ...mixins.boxShadow('0 10px 13px -2px rgba(0, 0, 0, 0.58),inset -5px 6px 8px -10px rgb(0 0 0 / 58%)'),
    '@media (max-width: 1000px),print': {
      position: 'fixed',
      left: '0',
      right: '0',
      top: '0',
      bottom: '100%',
      height: '100%',
      background: '#fff',
      zIndex: '600',
      overflow: 'auto',
      padding: '0',
      maxHeight: 'none',
      ...mixins.transition('bottom 1s')
    },
    '@media (min-width: 1200px),print': {
      right: '-117px',
    },
    '@media (min-width: 1001px),print':{
      margin: '1px 0 0',
    },
    '&:lang(ar)':{
      '@media (min-width: 1200px),print':{
        right:0,
        left:'-117px'
      }
    },
    '& $listContainer':{
      padding: '20px',
      '@media (min-width: 1000px),print': {
        padding: 0
      }
    }
  },
  buttonFilter: {
    font: data => '300 13px ' + data.fontFamily1,
    padding: '9px 6px',
    minWidth: '70px',
    textAlign: 'left',
    '&:lang(ar)': {
      textAlign: 'right'
    }
  },
  selected: {
    ...mixins.transition('.5s'),
    display: 'block'
  }
};
